module.exports = __webpack_public_path__ + "img/ysgj_001@2x.725adf1b.png";